module.exports = __webpack_public_path__ + "img/Surdurulebilirlik-2.6e070d2d.png";